import isFunction from 'lodash-es/isFunction';

const isPromise = (value: any): value is Promise<any> => {
  return value && isFunction(value.then) && isFunction(value.catch);
};

export { isPromise };
